module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-row', {
    key: _vm.refreshImport
  }, _vm._l((_vm.currentStep.fields), function(field, indexField) {
    return (_vm.showWithDependency(field, _vm.currentStep.fields)) ? _c('b-col', {
      key: indexField,
      staticClass: "form-group",
      attrs: {
        "sm": (field.type === 'file') ? '12' : '6'
      }
    }, [(field.type === 'date') ? _c('form-write-group-label-input', {
      attrs: {
        "inputLabel": _vm.$t('suppliers.kyc_form.' + _vm.currentStep.step_label + '.' + field.label),
        "inputType": "date"
      },
      model: {
        value: (field.value),
        callback: function($$v) {
          _vm.$set(field, "value", $$v)
        },
        expression: "field.value"
      }
    }) : (field.type === 'text') ? _c('div', [_c('label', [_vm._v("\n          " + _vm._s(_vm.$t('suppliers.kyc_form.' + _vm.currentStep.step_label + '.' + field.label)) + "\n          "), (field.required && field.required === 'true') ? _c('span', {
      staticClass: "color-red"
    }, [_vm._v("* ")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.value),
        expression: "field.value"
      }],
      staticClass: "form-control inputAccordionForm",
      class: (_vm.hasError(field)) ? 'errorBorder' : '',
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (field.value)
      },
      on: {
        "change": function($event) {
          _vm.refreshImport = !_vm.refreshImport
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(field, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), (!_vm.demoErrorSilent.includes(field.errorDesc)) ? _c('div', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n          " + _vm._s(field.errorDesc) + "\n        ")]) : _vm._e()]) : (field.type === 'checkbox') ? _c('div', [_c('label', [_vm._v("\n          " + _vm._s(_vm.$t('suppliers.kyc_form.' + _vm.currentStep.step_label + '.' + field.label)) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
      attrs: {
        "value": "true",
        "unchecked-value": "false"
      },
      on: {
        "change": function($event) {
          _vm.refreshImport = !_vm.refreshImport
        }
      },
      model: {
        value: (field.value),
        callback: function($$v) {
          _vm.$set(field, "value", $$v)
        },
        expression: "field.value"
      }
    })], 1) : (field.type === 'radio') ? _c('div', [_c('label', [_vm._v("\n          " + _vm._s(_vm.$t('suppliers.kyc_form.' + _vm.currentStep.step_label + '.' + field.label + '._label')) + "\n          "), (field.required && field.required === 'true') ? _c('span', {
      staticClass: "color-red"
    }, [_vm._v("* ")]) : _vm._e()]), _vm._v(" "), _vm._l((field.possible_values), function(radioValue) {
      return _c('b-form-radio', {
        key: radioValue,
        attrs: {
          "value": radioValue,
          "name": field.label + '-radio'
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      }, [_vm._v("\n          " + _vm._s(_vm.$t('suppliers.kyc_form.' + _vm.currentStep.step_label + '.' + field.label + '.' + radioValue)) + "\n        ")])
    })], 2) : (field.type === 'list') ? _c('form-write-group-label-input', {
      attrs: {
        "isMandatory": field.required && field.required === 'true',
        "inputLabel": _vm.$t('suppliers.kyc_form.' + _vm.currentStep.step_label + '.' + field.label + '._label'),
        "inputType": field.type
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.value),
        expression: "field.value"
      }],
      staticClass: "form-control",
      class: (_vm.hasError(field)) ? 'errorBorder' : '',
      attrs: {
        "readonly": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(field, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.checkInvalidValue(field)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((field.possible_values), function(optionValue) {
      return _c('option', {
        domProps: {
          "value": optionValue
        }
      }, [_vm._v("\n            " + _vm._s(_vm.$t('suppliers.kyc_form.' + _vm.currentStep.step_label + '.' + field.label + '.' + optionValue)) + "\n          ")])
    })], 2), _vm._v(" "), (!_vm.demoErrorSilent.includes(field.errorDesc)) ? _c('div', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n          " + _vm._s(field.errorDesc) + "\n        ")]) : _vm._e()]) : (field.type === 'file') ? _c('div', {
      staticClass: "row"
    }, [_c('b-col', {
      attrs: {
        "sm": "6"
      }
    }, [_c('label', [_vm._v("\n            " + _vm._s(_vm.$t('suppliers.kyc_form.' + _vm.currentStep.step_label + '.' + field.label)) + "\n            "), (field.required && field.required === 'true') ? _c('span', {
      staticClass: "color-red"
    }, [_vm._v("* ")]) : _vm._e()]), _vm._v(" "), (field.value === 'true') ? _c('div', [(_vm.step.documentData) ? _c('b-row', [_c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "4"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('label', {
      attrs: {
        "id": "application-file-input"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('attachments.' + _vm.step.documentType)) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex"
    }, [_c('i', {
      staticClass: "icon fa fa-download mx-1",
      on: {
        "click": function($event) {
          return _vm.download(_vm.step)
        }
      }
    })])])]), _vm._v(" "), _c('b-col', {
      staticClass: "form-group",
      attrs: {
        "sm": "4"
      }
    }, [_c('f7-button', {
      staticClass: "generalBottomButton",
      attrs: {
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.clearDocument(field)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.rm_label')) + "\n                ")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-row', {
      staticClass: "justify-content-start"
    }, [_c('b-col', {
      staticClass: "form-group"
    }, [_c('f7-button', {
      staticClass: "generalBottomButton",
      attrs: {
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.openFileSelectionWindow($event, 'fileButton' + field.label)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('attachments.import_doc')) + "\n              ")]), _vm._v(" "), _c('input', {
      ref: 'fileButton' + field.label,
      refInFor: true,
      staticClass: "item-input hiddenElementAllSize local-file-input",
      attrs: {
        "type": "file"
      },
      on: {
        "change": function($event) {
          return _vm.executeOCR($event, field, _vm.currentStep)
        }
      }
    })], 1)], 1), _vm._v(" "), _c('b-row', {
      staticClass: "justify-content-start"
    }, [(field.doc_type === 'KBIS' || field.doc_type === 'STATUS') ? _c('b-col', {
      staticClass: "form-group"
    }, [_c('f7-button', {
      staticClass: "generalBottomButton",
      attrs: {
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.callInstitutionalSource($event, field, _vm.currentStep)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('suppliers.ask_institut')) + "\n              ")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "sm": "6"
      }
    }, [(field.doc_type === 'BILAN') ? _c('f7-button', {
      staticClass: "generalBottomButton",
      staticStyle: {
        "margin-top": "26px"
      },
      attrs: {
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.callInstitutionalSourceInfo($event, field, _vm.currentStep)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('suppliers.ask_institut_info')) + "\n          ")]) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e()
  }), 1), _vm._v(" "), (_vm.showActionButtons()) ? _c('b-row', {
    staticClass: "justify-content-start"
  }, [(_vm.showActionButtonValidate()) ? [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3",
      "offset-md": "6"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.decideStep(102)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.sve')) + "\n        ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": _vm.checkKYCError()
    },
    on: {
      "click": function($event) {
        return _vm.decideStep(103)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('creation_forms.vldt')) + "\n        ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.showActionButtonValidateBackOffice()) ? [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3",
      "offset-md": "6"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.refuseStep()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "times"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('common.refus')) + "\n        ")], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.decideStep(104)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "check"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('creation_forms.vldt')) + "\n        ")], 1)], 1)] : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c6c1387", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c6c1387","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/supplierDetailPages/SupplierKYCFormStep.vue
// module id = 2427
// module chunks = 2